export { App as default } from '@guiker/tenant-application-main-mfe'
